var map = {
	"./assets/en/image4_2x.jpeg": 82135,
	"./assets/image4_2x.jpeg": 93608,
	"pages/home/assets/en/image4_2x.jpeg": 82135,
	"pages/home/assets/image4_2x.jpeg": 93608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45029;